var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"id":"detailsRow"}},[_c('div',{staticClass:"col-4 label-text"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"col-8"},[_vm._v(_vm._s(_vm.field))])])
}
var staticRenderFns = []

export { render, staticRenderFns }